import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/tailwind.css'
import { Icon } from '@iconify/vue2'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 导入配置好的 axios
import axios from './api/index.js'

Vue.use(ElementUI)
Vue.component('IconifyIcon', Icon)

// 将 axios 挂载到 Vue 原型
Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
